<template>
  <b-navbar transparent>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="@/assets/keep-logo.png" alt="keep-logo" />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item tag="router-link" :to="{ path: '/benefits' }"
        >Why KEEP?</b-navbar-item
      >
      <b-navbar-item tag="router-link" :to="{ path: '/#partners' }"
        >Partners</b-navbar-item
      >
      <a class="navbar-item" href="mailto:sophie.charpentier@chalmersindustriteknik.se">
        Get in Touch</a
      >
    </template>

    <template slot="end">
      <div class="keep-buttons">
        <ButtonLink
          text="Contact us"
          icon="!forward"
          type="is-secondary"
          class="topbar-button"
          to="mailto:sophie.charpentier@chalmersindustriteknik.se"
        />
        <Button
          text="Try Prototype"
          icon="!forward"
          class="topbar-button"
          @click.native="isOnboardingModalActive = true"
        />
      </div>
    </template>
  </b-navbar>
</template>

<script>
import { sync } from "vuex-pathify";
import Button from "@/components/Button.vue";
import ButtonLink from "@/components/ButtonLink.vue";

export default {
  name: "NavbarStart",
  components: { 
    ButtonLink,
    Button,
  },
  props: {},
  computed: {
    isOnboardingModalActive: sync("isOnboardingModalActive"),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/scss/global.scss";
.topbar-button {
  margin: 0.5rem 0.75rem;
  padding-top: .6rem;
  padding-bottom: .6rem;
}
nav.navbar {
  background-color: $background;
  padding: 0 1rem;
}

.navbar-item img {
  max-height: 1.3rem;
}

.button {
  font-family: acumin-pro, Avenir, Helvetica, Arial, sans-serif;
  font-size: 14px;
  background-color: $button-primary;
  color: white;
  border: none;
  border-radius: 3rem;
  padding: 0 1.3rem;
  &:hover {
    background-color: $button-primary-hover;
    color: white;
  }
}

.button.secondary {
  font-family: acumin-pro, Avenir, Helvetica, Arial, sans-serif;
  font-size: 14px;
  background-color: transparent;
  color: $text-primary;
  border: solid 1px;
  border-color: $text-primary;
  border-radius: 3rem;
  padding: 0 1.3rem;
  &:hover {
    background-color: $button-secondary-hover;
    color: $text-primary;
  }
}
.keep-buttons {
  display: flex;
  width: 100%;
  flex-flow: wrap;
  justify-content: space-between;
}
</style>
